import React, { useContext, useEffect } from 'react';
import styles from './styles.module.scss';
import AppContext from '../../hooks/appContext';
import { formatMoney, calcCartTotal, calcCartDiscount, calcCartTax } from '../../utils/helpers';
import doToast from '@/modules/storefront/components/doToast/doToast';
import { Spinner } from '../Loader';

const OrderPage = (props) => {
  const {
    shippingFormValues,
    cart,
    deliveryFee,
    coupon,
    discountAmt,
    setDiscountAmt,
    currentCurrency,
    getStoreTax,
    activeAttributes,
  } = useContext(AppContext);

  useEffect(() => {
    if (coupon) {
      let discountAmount = calcCartDiscount(
        cart,
        deliveryFee,
        coupon?.value,
        coupon?.type,
        currentCurrency,
        activeAttributes
      );
      setDiscountAmt(discountAmount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coupon]);

  let cartTax = getStoreTax();

  const taxAmount = calcCartTax(
    cart,
    cartTax,
    deliveryFee,
    coupon?.value,
    coupon?.type,
    currentCurrency,
    activeAttributes
  );

  const discountValueClasses = `${styles['fee-value']} ${styles.discount}`;
  const checkoutButtonClasses = `${styles.btn} ${styles['btn-checkout']}`;

  const calcItemTotal = (product) => {
    let totalValue = 0;

    if (product.variants && product.variants.length > 0) {
      const matchingVariant = product.variants.find((variant) =>
        product.matchingVariant.every((mv) =>
          variant.options.some((opt) => opt.label === mv.label && opt.value === mv.value)
        )
      );

      if (matchingVariant) {
        const matchingAmount = matchingVariant.amounts.find((amount) => amount.currency_id === currentCurrency);

        if (matchingAmount) {
          totalValue = matchingAmount.amount * product.qty;
        }
      }
    } else {
      const mainAmount = product.amounts.find((amount) => amount.currency_id === currentCurrency);

      if (mainAmount) {
        totalValue = mainAmount.amount * product.qty;
      }
    }

    return totalValue;
  };

  const handleChangeCartPage = () => {
    if (cart.length > 0) {
      props.createOrder(shippingFormValues);
    }
  };

  return (
    <>
      <div className={styles['order-page']}>
        <div className={styles['order-page-title']}>Order Details</div>
        <div className={styles['customer-details']}>
          <div className={styles['detail-single']}>
            <div className={styles['detail-title']}>Full Name</div>
            <div className={styles['detail-value']}>
              {shippingFormValues?.customerName ? shippingFormValues?.customerName : ''}
            </div>
          </div>
          <div className={styles['detail-single']}>
            <div className={styles['detail-title']}>Email</div>
            <div className={styles['detail-value']}>
              {shippingFormValues?.customerEmail ? shippingFormValues?.customerEmail : ''}
            </div>
          </div>
          <div className={styles['detail-single']}>
            <div className={styles['detail-title']}>Phone</div>
            <div className={styles['detail-value']}>
              {shippingFormValues?.dialCode && shippingFormValues?.phone
                ? shippingFormValues?.dialCode + shippingFormValues?.phone
                : ''}
            </div>
          </div>
          {shippingFormValues?.customerAddress && (
            <div className={styles['detail-single']}>
              <div className={styles['detail-title']}>Delivery Address</div>
              <div className={styles['detail-value']}>{shippingFormValues?.customerAddress}</div>
            </div>
          )}
        </div>

        <div className={styles['order-details']}>
          {cart && cart.length
            ? cart.map((item, index) => {
                return (
                  <div className={styles['single-detail']} key={index}>
                    <div className={styles['detail-title']}>
                      {item.name} <span className={styles.qty}>x{item.qty}</span>
                    </div>
                    <div className={styles['detail-amount']}>
                      <span dangerouslySetInnerHTML={{ __html: '&#8358;' }}></span>
                      {formatMoney(calcItemTotal(item) / 100)}
                    </div>
                  </div>
                );
              })
            : ''}

          {deliveryFee > 0 && (
            <div className={styles['single-detail']}>
              <div className={styles['detail-title']}>Delivery Fee </div>
              <div className={styles['detail-amount']}>
                <span dangerouslySetInnerHTML={{ __html: '&#8358;' }}></span>
                {formatMoney(parseInt(deliveryFee) / 100)}
              </div>
            </div>
          )}

          {cartTax && (
            <div className={styles['single-detail']}>
              <div className={styles['detail-title']}>Vat</div>
              <div className={styles['fee-value']}>
                {currentCurrency === 'NGN' ? <span dangerouslySetInnerHTML={{ __html: '&#8358;' }}></span> : '$'}{' '}
                {formatMoney(
                  calcCartTax(
                    cart,
                    cartTax,
                    deliveryFee,
                    coupon?.value,
                    coupon?.type,
                    currentCurrency,
                    activeAttributes
                  ) / 100
                )}
              </div>
            </div>
          )}

          {discountAmt > 0 && (
            <div className={styles['single-detail']}>
              <div className={styles['detail-title']}>Discount</div>
              <div className={discountValueClasses}>
                -{currentCurrency === 'NGN' ? <span dangerouslySetInnerHTML={{ __html: '&#8358;' }}></span> : '$'}{' '}
                {formatMoney(discountAmt / 100)}
              </div>
            </div>
          )}

          <div className={styles['total-detail']}>
            <div className={styles['detail-title']}>Sub Total</div>
            <div className={styles['detail-value']}>
              {currentCurrency === 'NGN' ? <span dangerouslySetInnerHTML={{ __html: '&#8358;' }}></span> : '$'}{' '}
              {formatMoney(
                (calcCartTotal(cart, currentCurrency) +
                  parseInt(deliveryFee) +
                  parseInt(taxAmount) -
                  parseInt(discountAmt)) /
                  100
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={styles['summary-bottom']}>
        <button className={checkoutButtonClasses} onClick={handleChangeCartPage} disabled={props.isLoadingModal}>
          {props.isLoadingModal ? <Spinner color="white" size={15} /> : 'Make Payment'}
        </button>
      </div>
    </>
  );
};

export default OrderPage;
